import Vue from "vue";
import _ from "lodash";
export const titleCase =  function (str) {  
    if(str){
        return str.split(' ').map(_.capitalize).join(' ');
    }
   
}

// You can also make it available globally.
Vue.filter('title-case', titleCase)